import queryString from 'query-string';
import { apiClient } from 'src/utils/api-client';
import type { ApiClient } from 'src/utils/api-client';
import {
  TourScheduleModel,
  TourDetailModel,
  TourAttendeeDetailModel,
  TourAttendeeNewModel,
  ResidentLeadInterestUpdateModel,
  Result,
  TourCustomRequestModel,
  HomeDetailParams1,
  TourRequestCreateModel,
  TourRequestModel,
  TourRequestTimeUpdateModel,
  TourAttendeeRescheduleModel,
} from './models';

export function fetchOpenHomeToursService(homeId: string, client: ApiClient = apiClient) {
  return client.get<TourScheduleModel>(`/homes/${homeId}/tours/OpenHome`);
}

export function fetchBookedToursService(homeId: string, client: ApiClient = apiClient) {
  return client.get<TourAttendeeDetailModel[]>(`/homes/${homeId}/tours/booked`);
}

export function bookTourService(data: TourAttendeeNewModel, client: ApiClient = apiClient) {
  return client.post<TourAttendeeNewModel>('/residents/tours', data);
}

export function rescheduleBookTourService(data: TourAttendeeRescheduleModel, client: ApiClient = apiClient) {
  return client.post<TourAttendeeNewModel>('/tours/reschedule', data);
}

export function confirmBookTourService(tourId: string, client: ApiClient = apiClient) {
  return client.put<void>(`/residents/tours/${tourId}/confirm`);
}

export function cancelTourService(id: string, client: ApiClient = apiClient) {
  return client.put<void>(`/residents/tours/${id}/cancel`);
}

export function cancelPrivateTour(tourId: string, client: ApiClient = apiClient) {
  return client.put<void>(`/tours/cancel/private-tour/${tourId}`);
}

export function updateHomeInterestService(
  homeId: string,
  data: ResidentLeadInterestUpdateModel,
  client: ApiClient = apiClient
) {
  return client.put<Result>(`/residents/home/${homeId}/interest-level`, data);
}

export function createCustomRequestService(data: TourCustomRequestModel, client: ApiClient = apiClient) {
  return client.post<void>('/residents/tours/custom-request', data);
}

export function getResidentTourRequests(client: ApiClient = apiClient) {
  return client.get<TourRequestModel[]>('/tour-requests');
}

export function createResidentTourRequest(data: TourRequestCreateModel, client: ApiClient = apiClient) {
  return client.post<TourRequestModel>('/tour-requests', data);
}

export function updateResidentTourRequest(
  tourRequestId: string,
  body: TourRequestTimeUpdateModel,
  client: ApiClient = apiClient
) {
  return client.put<TourRequestModel>(`/tour-requests/${tourRequestId}`, body);
}

export function fetchHomeToursService(
  homeId: string,
  client: ApiClient = apiClient,
  filters: Omit<HomeDetailParams1, 'homeUniqueId'> = {}
) {
  return client.get<TourDetailModel[]>(`/tours/home/${homeId}?${queryString.stringify(filters)}`);
}
